import { DocumentType } from '../../enums/document-type';
import { baseReducer as BaseReducer } from '../../store/core/base-reducer';

import * as Actions from './print-settings.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {
  v3Settings: {},
  printWarningSettings: {},
};

const actionHandlerMap = {
  [Actions.RESTORE_PRINT_SETTINGS_SUCCESS]: (state, { printSettings }) => {
    return {
      ...state,
      v3Settings: {
        ...state.v3Settings,
        ...printSettings,
      },
    };
  },
  [APP_INITIALIZATION]: (state, { initialData }) => {
    return {
      ...state,
      v3Settings: {
        ...state.v3Settings,
        ...initialData.printSettings,
      },
      printWarningSettings: {
        ...state.printWarningSettings,
        ...initialData.printWarningSettings,
      },
    };
  },
  [Actions.SAVE_PRINT_SETTINGS]: (state, { printSettingsKey, printer }) => {
    const { v3Settings } = state;
    const doctype = Object.values(DocumentType).find((docType) => docType.printSettingKey === printSettingsKey);
    if (!doctype) {
      return state;
    }
    const newSettings = {
      ...v3Settings,
      [doctype.printSettingKey]: printer,
    };
    return {
      ...state,
      v3Settings: newSettings,
    };
  },
  [Actions.CLEAR_ALL_SETTINGS_WITH_WORKSTATION]: (state, { workstationId }) => {
    const printSettingsMap = { ...state.v3Settings };

    const v3Settings = Object.keys(printSettingsMap).reduce((settings, docType) => {
      const printSetting = printSettingsMap[docType];
      return printSetting?.workstationId === workstationId ? settings : { ...settings, [docType]: printSetting };
    }, {});

    return {
      ...state,
      v3Settings,
    };
  },
  [Actions.SAVE_PRINT_WARNING_SETTINGS]: (state, { settingsKey, value }) => {
    return {
      ...state,
      printWarningSettings: {
        ...state.printWarningSettings,
        [settingsKey]: value,
      },
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './print-settings.reducer.metadata';
